import { dinero, toDecimal } from "dinero.js";
import { Currencies } from "venuescanner-js/constants/currencies";
import { PaymentCapabilities } from "venuescanner-js/constants/venue";

export function getTotal(cumulativeOffer, currencyCode) {
  const {
    cost,
    vat_included: vatIncluded,
    amount_in_pence: amountInPence,
    amount_in_pence_with_vat: amountInPenceWithVAT,
    vat_exempt: vatExempt,
    currency,
  } = cumulativeOffer;

  currencyCode = currency || currencyCode;

  const isVatIncluded = vatIncluded || (!vatIncluded && vatExempt);

  if (isOfferBeforeStripeConnect(cumulativeOffer) || isVatIncluded) {
    return amountInPence
      ? toDecimal(
          dinero({
            amount: amountInPence,
            currency: Currencies[currencyCode],
          })
        )
      : cost;
  }

  return amountInPenceWithVAT
    ? toDecimal(
        dinero({
          amount: amountInPenceWithVAT,
          currency: Currencies[currencyCode],
        })
      )
    : cost;
}

export function isOfferBeforeStripeConnect(cumulativeOffer) {
  return (
    !cumulativeOffer.payment_type ||
    cumulativeOffer.payment_type === PaymentCapabilities.OFFLINE_PAYMENT
  );
}
